// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../tolemac/pub/filter";
import * as dep_2 from "./../google/protobuf/empty";

export enum ReportType {
    UNDEFINED_ReportType = 0,
    ATTENDANCE = 1,
    HOURS = 2,
    COMPENSATION = 3,
    EXTENSION = 4,
    REGISTRATION = 5,
    CREDIT = 6,
    INTERRUPTION = 7,
    ATTENDANCE_CA = 8,
}
export interface IReport {
    type?: ReportType;
    adviser?: string;
    source?: string;
    trainee?: string;
    packagetraining?: string;
    contratDate?: number;
    startAt?: number;
    endAt?: number;
    funderName?: string;
    funderAmount?: number;
    soldDuration?: number;
    hourlyRate?: number;
    date?: number;
    workDuration?: number;
    amount?: number;
    packageFileId?: number;
    contactId?: number;
    invoiceId?: number;
    invoiceNumber?: number;

}
export class Report implements IReport {

    type?: ReportType;
    adviser?: string;
    source?: string;
    trainee?: string;
    packagetraining?: string;
    contratDate?: number;
    startAt?: number;
    endAt?: number;
    funderName?: string;
    funderAmount?: number;
    soldDuration?: number;
    hourlyRate?: number;
    date?: number;
    workDuration?: number;
    amount?: number;
    packageFileId?: number;
    contactId?: number;
    invoiceId?: number;
    invoiceNumber?: number;

    constructor(data?: Partial<IReport>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MReport extends Message implements Report {

    constructor(data?: Partial<IReport>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("type" in data && data.type != undefined) this.type = data.type;
            if ("adviser" in data && data.adviser != undefined) this.adviser = data.adviser;
            if ("source" in data && data.source != undefined) this.source = data.source;
            if ("trainee" in data && data.trainee != undefined) this.trainee = data.trainee;
            if ("packagetraining" in data && data.packagetraining != undefined) this.packagetraining = data.packagetraining;
            if ("contratDate" in data && data.contratDate != undefined) this.contratDate = data.contratDate;
            if ("startAt" in data && data.startAt != undefined) this.startAt = data.startAt;
            if ("endAt" in data && data.endAt != undefined) this.endAt = data.endAt;
            if ("funderName" in data && data.funderName != undefined) this.funderName = data.funderName;
            if ("funderAmount" in data && data.funderAmount != undefined) this.funderAmount = data.funderAmount;
            if ("soldDuration" in data && data.soldDuration != undefined) this.soldDuration = data.soldDuration;
            if ("hourlyRate" in data && data.hourlyRate != undefined) this.hourlyRate = data.hourlyRate;
            if ("date" in data && data.date != undefined) this.date = data.date;
            if ("workDuration" in data && data.workDuration != undefined) this.workDuration = data.workDuration;
            if ("amount" in data && data.amount != undefined) this.amount = data.amount;
            if ("packageFileId" in data && data.packageFileId != undefined) this.packageFileId = data.packageFileId;
            if ("contactId" in data && data.contactId != undefined) this.contactId = data.contactId;
            if ("invoiceId" in data && data.invoiceId != undefined) this.invoiceId = data.invoiceId;
            if ("invoiceNumber" in data && data.invoiceNumber != undefined) this.invoiceNumber = data.invoiceNumber;
        }
    }

    get type(): ReportType {
        return Message.getField(this, 1) as ReportType;
    }
    set type(value: ReportType) {
        Message.setField(this, 1, value);
    }

    get adviser(): string {
        return Message.getField(this, 2) as string;
    }
    set adviser(value: string) {
        Message.setField(this, 2, value);
    }

    get source(): string {
        return Message.getField(this, 3) as string;
    }
    set source(value: string) {
        Message.setField(this, 3, value);
    }

    get trainee(): string {
        return Message.getField(this, 4) as string;
    }
    set trainee(value: string) {
        Message.setField(this, 4, value);
    }

    get packagetraining(): string {
        return Message.getField(this, 6) as string;
    }
    set packagetraining(value: string) {
        Message.setField(this, 6, value);
    }

    get contratDate(): number {
        return Message.getField(this, 7) as number;
    }
    set contratDate(value: number) {
        Message.setField(this, 7, value);
    }

    get startAt(): number {
        return Message.getField(this, 8) as number;
    }
    set startAt(value: number) {
        Message.setField(this, 8, value);
    }

    get endAt(): number {
        return Message.getField(this, 9) as number;
    }
    set endAt(value: number) {
        Message.setField(this, 9, value);
    }

    get funderName(): string {
        return Message.getField(this, 10) as string;
    }
    set funderName(value: string) {
        Message.setField(this, 10, value);
    }

    get funderAmount(): number {
        return Message.getField(this, 11) as number;
    }
    set funderAmount(value: number) {
        Message.setField(this, 11, value);
    }

    get soldDuration(): number {
        return Message.getField(this, 12) as number;
    }
    set soldDuration(value: number) {
        Message.setField(this, 12, value);
    }

    get hourlyRate(): number {
        return Message.getField(this, 13) as number;
    }
    set hourlyRate(value: number) {
        Message.setField(this, 13, value);
    }

    get date(): number {
        return Message.getField(this, 14) as number;
    }
    set date(value: number) {
        Message.setField(this, 14, value);
    }

    get workDuration(): number {
        return Message.getField(this, 15) as number;
    }
    set workDuration(value: number) {
        Message.setField(this, 15, value);
    }

    get amount(): number {
        return Message.getField(this, 16) as number;
    }
    set amount(value: number) {
        Message.setField(this, 16, value);
    }

    get packageFileId(): number {
        return Message.getField(this, 17) as number;
    }
    set packageFileId(value: number) {
        Message.setField(this, 17, value);
    }

    get contactId(): number {
        return Message.getField(this, 18) as number;
    }
    set contactId(value: number) {
        Message.setField(this, 18, value);
    }

    get invoiceId(): number {
        return Message.getField(this, 19) as number;
    }
    set invoiceId(value: number) {
        Message.setField(this, 19, value);
    }

    get invoiceNumber(): number {
        return Message.getField(this, 20) as number;
    }
    set invoiceNumber(value: number) {
        Message.setField(this, 20, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Report() : {} as Report;
        if (this.type != undefined) data.type = this.type;
        if (this.adviser != undefined) data.adviser = this.adviser;
        if (this.source != undefined) data.source = this.source;
        if (this.trainee != undefined) data.trainee = this.trainee;
        if (this.packagetraining != undefined) data.packagetraining = this.packagetraining;
        if (this.contratDate != undefined) data.contratDate = this.contratDate;
        if (this.startAt != undefined) data.startAt = this.startAt;
        if (this.endAt != undefined) data.endAt = this.endAt;
        if (this.funderName != undefined) data.funderName = this.funderName;
        if (this.funderAmount != undefined) data.funderAmount = this.funderAmount;
        if (this.soldDuration != undefined) data.soldDuration = this.soldDuration;
        if (this.hourlyRate != undefined) data.hourlyRate = this.hourlyRate;
        if (this.date != undefined) data.date = this.date;
        if (this.workDuration != undefined) data.workDuration = this.workDuration;
        if (this.amount != undefined) data.amount = this.amount;
        if (this.packageFileId != undefined) data.packageFileId = this.packageFileId;
        if (this.contactId != undefined) data.contactId = this.contactId;
        if (this.invoiceId != undefined) data.invoiceId = this.invoiceId;
        if (this.invoiceNumber != undefined) data.invoiceNumber = this.invoiceNumber;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.type !== undefined) writer.writeEnum(1, this.type);
                if (this.adviser !== undefined) writer.writeString(2, this.adviser);
                if (this.source !== undefined) writer.writeString(3, this.source);
                if (this.trainee !== undefined) writer.writeString(4, this.trainee);
                if (this.packagetraining !== undefined) writer.writeString(6, this.packagetraining);
                if (this.contratDate !== undefined) writer.writeInt64(7, this.contratDate);
                if (this.startAt !== undefined) writer.writeInt64(8, this.startAt);
                if (this.endAt !== undefined) writer.writeInt64(9, this.endAt);
                if (this.funderName !== undefined) writer.writeString(10, this.funderName);
                if (this.funderAmount !== undefined) writer.writeDouble(11, this.funderAmount);
                if (this.soldDuration !== undefined) writer.writeInt32(12, this.soldDuration);
                if (this.hourlyRate !== undefined) writer.writeDouble(13, this.hourlyRate);
                if (this.date !== undefined) writer.writeInt64(14, this.date);
                if (this.workDuration !== undefined) writer.writeInt32(15, this.workDuration);
                if (this.amount !== undefined) writer.writeDouble(16, this.amount);
                if (this.packageFileId !== undefined) writer.writeInt32(17, this.packageFileId);
                if (this.contactId !== undefined) writer.writeInt32(18, this.contactId);
                if (this.invoiceId !== undefined) writer.writeInt32(19, this.invoiceId);
                if (this.invoiceNumber !== undefined) writer.writeInt32(20, this.invoiceNumber);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IReport): Uint8Array {
        return (data instanceof Message ? (data as MReport) : new MReport(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MReport {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MReport();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.type = reader.readEnum();
                    break;
            case 2:
                    message.adviser = reader.readString();
                    break;
            case 3:
                    message.source = reader.readString();
                    break;
            case 4:
                    message.trainee = reader.readString();
                    break;
            case 6:
                    message.packagetraining = reader.readString();
                    break;
            case 7:
                    message.contratDate = reader.readInt64();
                    break;
            case 8:
                    message.startAt = reader.readInt64();
                    break;
            case 9:
                    message.endAt = reader.readInt64();
                    break;
            case 10:
                    message.funderName = reader.readString();
                    break;
            case 11:
                    message.funderAmount = reader.readDouble();
                    break;
            case 12:
                    message.soldDuration = reader.readInt32();
                    break;
            case 13:
                    message.hourlyRate = reader.readDouble();
                    break;
            case 14:
                    message.date = reader.readInt64();
                    break;
            case 15:
                    message.workDuration = reader.readInt32();
                    break;
            case 16:
                    message.amount = reader.readDouble();
                    break;
            case 17:
                    message.packageFileId = reader.readInt32();
                    break;
            case 18:
                    message.contactId = reader.readInt32();
                    break;
            case 19:
                    message.invoiceId = reader.readInt32();
                    break;
            case 20:
                    message.invoiceNumber = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MReport {
        return MReport.deserializeBinaryFromReader(new MReport(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MReport, reader: BinaryReader) {
        return Object.assign(msg, MReport.deserialize(reader))
    };

}
export interface IReports {
    values?: IReport[];
    count?: number;

}
export class Reports implements IReports {

    values: Report[];
    count?: number;

    constructor(data?: Partial<IReports>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MReports extends Message implements Reports {

    constructor(data?: Partial<IReports>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MReport(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MReport[] {
        return Message.getRepeatedWrapperField(this, MReport, 1);
    }
    set values(value: MReport[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Reports() : {} as Reports;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IReports): Uint8Array {
        return (data instanceof Message ? (data as MReports) : new MReports(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MReports {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MReports();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MReport.deserialize(reader), MReport));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MReports {
        return MReports.deserializeBinaryFromReader(new MReports(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MReports, reader: BinaryReader) {
        return Object.assign(msg, MReports.deserialize(reader))
    };

}
export interface ILead {
    contactId?: number;
    status?: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactCellphone?: string;
    adviser?: string;
    packageFileId?: number;
    package?: string;
    webFormSubmissionStatus?: string;
    webFormSubmissionDate?: number;
    webFormSource?: string;
    applicationAdmissionStatus?: string;
    applicationAdmissionDate?: number;
    applicationSentDate?: number;
    applicationReceivedDate?: number;
    applicationReceived?: boolean;
    packageStartAt?: number;
    packageEndAt?: number;

}
export class Lead implements ILead {

    contactId?: number;
    status?: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactCellphone?: string;
    adviser?: string;
    packageFileId?: number;
    package?: string;
    webFormSubmissionStatus?: string;
    webFormSubmissionDate?: number;
    webFormSource?: string;
    applicationAdmissionStatus?: string;
    applicationAdmissionDate?: number;
    applicationSentDate?: number;
    applicationReceivedDate?: number;
    applicationReceived?: boolean;
    packageStartAt?: number;
    packageEndAt?: number;

    constructor(data?: Partial<ILead>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MLead extends Message implements Lead {

    constructor(data?: Partial<ILead>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("contactId" in data && data.contactId != undefined) this.contactId = data.contactId;
            if ("status" in data && data.status != undefined) this.status = data.status;
            if ("contactName" in data && data.contactName != undefined) this.contactName = data.contactName;
            if ("contactEmail" in data && data.contactEmail != undefined) this.contactEmail = data.contactEmail;
            if ("contactPhone" in data && data.contactPhone != undefined) this.contactPhone = data.contactPhone;
            if ("contactCellphone" in data && data.contactCellphone != undefined) this.contactCellphone = data.contactCellphone;
            if ("adviser" in data && data.adviser != undefined) this.adviser = data.adviser;
            if ("packageFileId" in data && data.packageFileId != undefined) this.packageFileId = data.packageFileId;
            if ("package" in data && data.package != undefined) this.package = data.package;
            if ("webFormSubmissionStatus" in data && data.webFormSubmissionStatus != undefined) this.webFormSubmissionStatus = data.webFormSubmissionStatus;
            if ("webFormSubmissionDate" in data && data.webFormSubmissionDate != undefined) this.webFormSubmissionDate = data.webFormSubmissionDate;
            if ("webFormSource" in data && data.webFormSource != undefined) this.webFormSource = data.webFormSource;
            if ("applicationAdmissionStatus" in data && data.applicationAdmissionStatus != undefined) this.applicationAdmissionStatus = data.applicationAdmissionStatus;
            if ("applicationAdmissionDate" in data && data.applicationAdmissionDate != undefined) this.applicationAdmissionDate = data.applicationAdmissionDate;
            if ("applicationSentDate" in data && data.applicationSentDate != undefined) this.applicationSentDate = data.applicationSentDate;
            if ("applicationReceivedDate" in data && data.applicationReceivedDate != undefined) this.applicationReceivedDate = data.applicationReceivedDate;
            if ("applicationReceived" in data && data.applicationReceived != undefined) this.applicationReceived = data.applicationReceived;
            if ("packageStartAt" in data && data.packageStartAt != undefined) this.packageStartAt = data.packageStartAt;
            if ("packageEndAt" in data && data.packageEndAt != undefined) this.packageEndAt = data.packageEndAt;
        }
    }

    get contactId(): number {
        return Message.getField(this, 1) as number;
    }
    set contactId(value: number) {
        Message.setField(this, 1, value);
    }

    get status(): string {
        return Message.getField(this, 2) as string;
    }
    set status(value: string) {
        Message.setField(this, 2, value);
    }

    get contactName(): string {
        return Message.getField(this, 3) as string;
    }
    set contactName(value: string) {
        Message.setField(this, 3, value);
    }

    get contactEmail(): string {
        return Message.getField(this, 4) as string;
    }
    set contactEmail(value: string) {
        Message.setField(this, 4, value);
    }

    get contactPhone(): string {
        return Message.getField(this, 5) as string;
    }
    set contactPhone(value: string) {
        Message.setField(this, 5, value);
    }

    get contactCellphone(): string {
        return Message.getField(this, 6) as string;
    }
    set contactCellphone(value: string) {
        Message.setField(this, 6, value);
    }

    get adviser(): string {
        return Message.getField(this, 7) as string;
    }
    set adviser(value: string) {
        Message.setField(this, 7, value);
    }

    get packageFileId(): number {
        return Message.getField(this, 8) as number;
    }
    set packageFileId(value: number) {
        Message.setField(this, 8, value);
    }

    get package(): string {
        return Message.getField(this, 9) as string;
    }
    set package(value: string) {
        Message.setField(this, 9, value);
    }

    get webFormSubmissionStatus(): string {
        return Message.getField(this, 10) as string;
    }
    set webFormSubmissionStatus(value: string) {
        Message.setField(this, 10, value);
    }

    get webFormSubmissionDate(): number {
        return Message.getField(this, 11) as number;
    }
    set webFormSubmissionDate(value: number) {
        Message.setField(this, 11, value);
    }

    get webFormSource(): string {
        return Message.getField(this, 12) as string;
    }
    set webFormSource(value: string) {
        Message.setField(this, 12, value);
    }

    get applicationAdmissionStatus(): string {
        return Message.getField(this, 13) as string;
    }
    set applicationAdmissionStatus(value: string) {
        Message.setField(this, 13, value);
    }

    get applicationAdmissionDate(): number {
        return Message.getField(this, 14) as number;
    }
    set applicationAdmissionDate(value: number) {
        Message.setField(this, 14, value);
    }

    get applicationSentDate(): number {
        return Message.getField(this, 15) as number;
    }
    set applicationSentDate(value: number) {
        Message.setField(this, 15, value);
    }

    get applicationReceivedDate(): number {
        return Message.getField(this, 16) as number;
    }
    set applicationReceivedDate(value: number) {
        Message.setField(this, 16, value);
    }

    get applicationReceived(): boolean {
        return Message.getField(this, 17) as boolean;
    }
    set applicationReceived(value: boolean) {
        Message.setField(this, 17, value);
    }

    get packageStartAt(): number {
        return Message.getField(this, 18) as number;
    }
    set packageStartAt(value: number) {
        Message.setField(this, 18, value);
    }

    get packageEndAt(): number {
        return Message.getField(this, 19) as number;
    }
    set packageEndAt(value: number) {
        Message.setField(this, 19, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Lead() : {} as Lead;
        if (this.contactId != undefined) data.contactId = this.contactId;
        if (this.status != undefined) data.status = this.status;
        if (this.contactName != undefined) data.contactName = this.contactName;
        if (this.contactEmail != undefined) data.contactEmail = this.contactEmail;
        if (this.contactPhone != undefined) data.contactPhone = this.contactPhone;
        if (this.contactCellphone != undefined) data.contactCellphone = this.contactCellphone;
        if (this.adviser != undefined) data.adviser = this.adviser;
        if (this.packageFileId != undefined) data.packageFileId = this.packageFileId;
        if (this.package != undefined) data.package = this.package;
        if (this.webFormSubmissionStatus != undefined) data.webFormSubmissionStatus = this.webFormSubmissionStatus;
        if (this.webFormSubmissionDate != undefined) data.webFormSubmissionDate = this.webFormSubmissionDate;
        if (this.webFormSource != undefined) data.webFormSource = this.webFormSource;
        if (this.applicationAdmissionStatus != undefined) data.applicationAdmissionStatus = this.applicationAdmissionStatus;
        if (this.applicationAdmissionDate != undefined) data.applicationAdmissionDate = this.applicationAdmissionDate;
        if (this.applicationSentDate != undefined) data.applicationSentDate = this.applicationSentDate;
        if (this.applicationReceivedDate != undefined) data.applicationReceivedDate = this.applicationReceivedDate;
        if (this.applicationReceived != undefined) data.applicationReceived = this.applicationReceived;
        if (this.packageStartAt != undefined) data.packageStartAt = this.packageStartAt;
        if (this.packageEndAt != undefined) data.packageEndAt = this.packageEndAt;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.contactId !== undefined) writer.writeInt32(1, this.contactId);
                if (this.status !== undefined) writer.writeString(2, this.status);
                if (this.contactName !== undefined) writer.writeString(3, this.contactName);
                if (this.contactEmail !== undefined) writer.writeString(4, this.contactEmail);
                if (this.contactPhone !== undefined) writer.writeString(5, this.contactPhone);
                if (this.contactCellphone !== undefined) writer.writeString(6, this.contactCellphone);
                if (this.adviser !== undefined) writer.writeString(7, this.adviser);
                if (this.packageFileId !== undefined) writer.writeInt32(8, this.packageFileId);
                if (this.package !== undefined) writer.writeString(9, this.package);
                if (this.webFormSubmissionStatus !== undefined) writer.writeString(10, this.webFormSubmissionStatus);
                if (this.webFormSubmissionDate !== undefined) writer.writeInt64(11, this.webFormSubmissionDate);
                if (this.webFormSource !== undefined) writer.writeString(12, this.webFormSource);
                if (this.applicationAdmissionStatus !== undefined) writer.writeString(13, this.applicationAdmissionStatus);
                if (this.applicationAdmissionDate !== undefined) writer.writeInt64(14, this.applicationAdmissionDate);
                if (this.applicationSentDate !== undefined) writer.writeInt64(15, this.applicationSentDate);
                if (this.applicationReceivedDate !== undefined) writer.writeInt64(16, this.applicationReceivedDate);
                if (this.applicationReceived !== undefined) writer.writeBool(17, this.applicationReceived);
                if (this.packageStartAt !== undefined) writer.writeInt64(18, this.packageStartAt);
                if (this.packageEndAt !== undefined) writer.writeInt64(19, this.packageEndAt);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ILead): Uint8Array {
        return (data instanceof Message ? (data as MLead) : new MLead(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MLead {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MLead();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.contactId = reader.readInt32();
                    break;
            case 2:
                    message.status = reader.readString();
                    break;
            case 3:
                    message.contactName = reader.readString();
                    break;
            case 4:
                    message.contactEmail = reader.readString();
                    break;
            case 5:
                    message.contactPhone = reader.readString();
                    break;
            case 6:
                    message.contactCellphone = reader.readString();
                    break;
            case 7:
                    message.adviser = reader.readString();
                    break;
            case 8:
                    message.packageFileId = reader.readInt32();
                    break;
            case 9:
                    message.package = reader.readString();
                    break;
            case 10:
                    message.webFormSubmissionStatus = reader.readString();
                    break;
            case 11:
                    message.webFormSubmissionDate = reader.readInt64();
                    break;
            case 12:
                    message.webFormSource = reader.readString();
                    break;
            case 13:
                    message.applicationAdmissionStatus = reader.readString();
                    break;
            case 14:
                    message.applicationAdmissionDate = reader.readInt64();
                    break;
            case 15:
                    message.applicationSentDate = reader.readInt64();
                    break;
            case 16:
                    message.applicationReceivedDate = reader.readInt64();
                    break;
            case 17:
                    message.applicationReceived = reader.readBool();
                    break;
            case 18:
                    message.packageStartAt = reader.readInt64();
                    break;
            case 19:
                    message.packageEndAt = reader.readInt64();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MLead {
        return MLead.deserializeBinaryFromReader(new MLead(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MLead, reader: BinaryReader) {
        return Object.assign(msg, MLead.deserialize(reader))
    };

}
export interface ILeads {
    values?: ILead[];
    count?: number;

}
export class Leads implements ILeads {

    values: Lead[];
    count?: number;

    constructor(data?: Partial<ILeads>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MLeads extends Message implements Leads {

    constructor(data?: Partial<ILeads>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MLead(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MLead[] {
        return Message.getRepeatedWrapperField(this, MLead, 1);
    }
    set values(value: MLead[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Leads() : {} as Leads;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ILeads): Uint8Array {
        return (data instanceof Message ? (data as MLeads) : new MLeads(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MLeads {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MLeads();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MLead.deserialize(reader), MLead));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MLeads {
        return MLeads.deserializeBinaryFromReader(new MLeads(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MLeads, reader: BinaryReader) {
        return Object.assign(msg, MLeads.deserialize(reader))
    };

}
                        




export default () => {}